export default __webpack_public_path__ + "static/media/chicken-cheese.e0574527.jpg";